// /login is an alias for /signin — both render the LoginWindow chrome
// (modal-style card with Google/GitHub OAuth + email/password form).
// Keep the export name `login` so existing route tables
// (workspace-project/pages/index.js maps `/login` to it) don't change.
export { signin as login } from './signin.js'
